import React, { useCallback, useEffect, useState } from "react"
import QrReader from "react-qr-reader"
import XLSX from "xlsx"

import Success from "../shared/success"
import Button from "../shared/button"
import UserEventApi from "../services/api/UserEvent.api"
import UserLinkApi from "../services/api/UserLink.api"
import { getUserId } from "../services/helper"
import MessageError from "../shared/message.error"
import { IUserLink } from "../interfaces/userLink"

const style = {
  width: "100%",
  maxWidth: "calc(100vh - 300px)",
  margin: "0 auto"
}

const Scan = () => {
  const [error, setError] = useState<string>("")
  const [success, setSuccess] = useState<boolean>(false)
  const [data, setData] = useState<string | null>(null)
  const [links, setLinks] = useState<IUserLink[]>([])

  const fetchUserLinks = useCallback(() => {
    new UserLinkApi(getUserId()).getAllByUserId().then(l => setLinks(l))
  }, [])

  useEffect(() => {
    fetchUserLinks()
  }, [fetchUserLinks])

  const createUserLink = async (newData: string | null) => {
    if (newData && newData !== data) {
      setError("")
      setSuccess(false)
      setData(newData)

      let value = ""
      try {
        value = new URL(newData).searchParams.get("C") || ""
      } catch {
        value = newData
      }

      try {
        const userWithUserEvent = await new UserEventApi().getOne({
          code: value
        })

        await new UserLinkApi(getUserId()).createOne(userWithUserEvent.id)

        setSuccess(true)
      } catch (err) {
        setError(err.message)
      } finally {
        setTimeout(() => {
          setSuccess(false)
        }, 3000)
      }
    }
  }

  const exportLinks = () => {
    const linksWithHeader = [
      {
        firstName: "Contact",
        lastName: "",
        email: "",
        companyName: "Société"
      },
      {
        firstName: "Prénom",
        lastName: "Nom",
        email: "Email",
        companyName: "Nom",
        companySocialReason: "Raison sociale",
        companyAddress1: "Adresse",
        companyAddress2: "Complément d'adresse",
        companyPostalCode: "Code postal",
        companyCity: "Ville"
      },
      ...links.map(({ UserB }) => {
        const company = UserB.UserEvent?.Employee?.Company
        return {
          firstName: UserB.firstName,
          lastName: UserB.lastName,
          email: UserB.Authentication?.email,
          companyName: company?.name,
          companySocialReason: company?.corporateName,
          companyAddress1: company?.address1,
          companyAddress2: company?.address2,
          companyPostalCode: company?.postalCode,
          companyCity: company?.city
        }
      })
    ]

    const colsWidth = []
    for (const property in linksWithHeader[1]) {
      if (linksWithHeader[1].hasOwnProperty(property)) {
        const max = Math.max.apply(
          Math,
          linksWithHeader.map(
            (u: any) => (u[property] ? u[property].toString() : "").length
          )
        )
        colsWidth.push({ wch: max < 20 ? 20 : max })
      }
    }

    const ws = XLSX.utils.json_to_sheet(linksWithHeader, { skipHeader: true })
    ws["!cols"] = colsWidth
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, "Export")
    XLSX.writeFile(wb, "export.xlsx")
  }

  return (
    <div>
      <Success isSuccess={success} message="Un lien a été créé" />
      <MessageError message={error} />
      <Button
        onClick={() => exportLinks()}
        label={`Télécharger les liens (${links.length})`}
        labelSuccess="Téléchargement en cours"
        style={{ marginBottom: 10 }}
      />
      <div
        className="field"
        style={success ? { border: "20px solid green", ...style } : style}
      >
        <QrReader
          delay={500}
          onError={() =>
            setError("Veuillez activer la caméra et recharger la page")
          }
          onScan={async newData => createUserLink(newData)}
        />
      </div>
    </div>
  )
}

export default Scan
